// extracted by mini-css-extract-plugin
module.exports = {"banner":"s_J","bannerContent":"s_cq","title":"s_p","description":"s_h","button":"s_w","logosContainer":"s_cr","uses":"s_bd"};